import React from 'react';
import "./style.css";

import WorkflowDesigner from '@optimajet/workflow-designer-react';

const CreateWorkflow = () => {
 
  const props = {
    designerConfig: {
     // apiurl: 'http://localhost/xmltojson/chatbuilderapi.php',
     //apiurl: 'http://192.168.0.42/xmltojson/dynamicval.php',
     apiurl: 'http://localhost/xmltojson/dynamicval.php',
     //apiurl: 'https://demo.workflowengine.io/Designer/API',

     //apiurl: 'http://192.168.0.33:80/chatbotbuilderapi/chatbuilderapi.php',
      name: 'wfe',
      language: 'en',
      
    },
    schemeCode: 'workflow',
    loadError: error => console.error(error),
    // onLoadDesigner: () => {
    // },
    readOnly: false,
  }
  


  return (
    <div style={{marginTop:"100px",marginLeft:"100px"}}>
      
       <WorkflowDesigner {...props} />
    
    </div>
  );
};

export default CreateWorkflow;
